import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'

export const getCssPackPath = (): string => window.TINYMCE_STYLES_PATH

export const getDefaultCssPackPath = (): string => '/packs/skins/ui/oxide/content.min.css'

export const getUploadImagePath = (): string => routes.crm_attachments_path()

export const uploadHandler = (blobInfo, success, failure, uploadImagePath, hint?) => {
  let xhr = null
  let formData = null

  xhr = new XMLHttpRequest()
  xhr.withCredentials = false
  xhr.open('POST', uploadImagePath())
  xhr.onload = (): void => {
    let json = null

    if (xhr.status !== 200) {
      return failure('HTTP Error: ' + xhr.status)
    }
    json = JSON.parse(xhr.responseText)

    if (!json || typeof json.image.url !== 'string') {
      return failure('Invalid JSON: ' + xhr.responseText)
    }

    return success(json.image.url)
  }

  formData = new FormData()
  if (hint !== undefined) {
    formData.append('hint', hint)
  }
  formData.append('authenticity_token', $('[name="csrf-token"]').attr('content'))
  formData.append('file', blobInfo.blob(), blobInfo.filename())
  xhr.send(formData)
}
